import { HubConnection, HubConnectionState } from '@microsoft/signalr';
import { ThunkAction } from 'redux-thunk';
import IStoreState from 'store/IStoreState';
import {
  GetSystemMaintenanceAction,
  NotificationsFromStore,
  RBACAction,
  SignalRConnectionAction,
} from './actions';
import { actionTriggers as sharedActionTriggers } from 'shared/stateManagement/actionsCreator';
import { PopupNotificationActions } from 'modules/popupNotification/stateManagement/actions';
import {
  OnboardEmployeeOpenToWorkAction,
  OnboardEmployeeRolesAction,
  OnboardEmployeeSkillsAction,
} from 'modules/profile/stateManagement/actions';
import { actionTriggers as homeActionTriggers } from 'modules/profile/stateManagement/actionsCreator';
import {
  axiosOnboardEmployeeOpenToWork,
  // axiosOnboardEmployeeRoles,
} from 'modules/profile/stateManagement/api';
import i18n from 'i18next';
import { INotificationFromStore } from 'shared/models/INotification.interface';
import {
  axiosGetNotificationsFromStore,
  axiosGetSystemMaintenance,
} from './api';
import { IErrorScreen } from 'shared/models/IErrorScreen.interface';
import { IRBACState } from './state';

export const startConnection =
  (
    connection: HubConnection | null
  ): ThunkAction<
    void,
    IStoreState,
    null,
    SignalRConnectionAction | PopupNotificationActions
  > =>
  async (dispatch) => {
    if (connection) {
      try {
        if (connection.state === HubConnectionState.Disconnected) {
          await connection.start();
          dispatch(sharedActionTriggers.sinalRConnectionSuccess(connection));
        }
      } catch (err) {
        dispatch(sharedActionTriggers.sinalRConnectionFailed());
      }
    } else {
      dispatch(sharedActionTriggers.sinalRConnectionFailed());
    }
  };

export const onboardEmployeeIfNecessary =
  (): ThunkAction<
    void,
    IStoreState,
    null,
    | OnboardEmployeeSkillsAction
    | OnboardEmployeeRolesAction
    | OnboardEmployeeOpenToWorkAction
  > =>
  async (dispatch, getState) => {
    if (getState()?.employee?.employee) {
      if (
        !getState()?.onboardEmployeeOpenToWork?.isUpdatingOpenToWork &&
        getState()?.employee?.employeeProfileFlags?.forceOpenToWork
      ) {
        dispatch(homeActionTriggers.onboardEmployeeOpenToWorkStarted());
        axiosOnboardEmployeeOpenToWork().then((response: number) => {
          if (response >= 200 && response <= 299) {
            dispatch(homeActionTriggers.onboardEmployeeOpenToWorkSuccess());
          } else {
            dispatch(homeActionTriggers.onboardEmployeeOpenToWorkFailed());
          }
        });
      }
    }
  };

export const getNotificationsFromStore =
  (): ThunkAction<
    void,
    IStoreState,
    null,
    NotificationsFromStore | PopupNotificationActions
  > =>
  async (dispatch, getState) => {
    if (getState()?.notificationsFromStore?.isFetchingData) {
      return;
    }

    dispatch(sharedActionTriggers.getNotificationsFromStoreStarted());

    await axiosGetNotificationsFromStore()
      .then((response: INotificationFromStore[]) => {
        dispatch(
          sharedActionTriggers.getNotificationsFromStoreSuccess(response)
        );
      })
      .catch(() => {
        dispatch(
          sharedActionTriggers.getNotificationsFromStoreFailed(
            i18n.t('failToLoadNotificationsFromStore')
          )
        );
      });
  };

export const getSystemMaintenance =
  (): ThunkAction<void, IStoreState, null, GetSystemMaintenanceAction> =>
  async (dispatch) => {
    dispatch(sharedActionTriggers.GetSystemMaintenanceStarted());
    await axiosGetSystemMaintenance().then((response: IErrorScreen | null) => {
      dispatch(
        response
          ? sharedActionTriggers.GetSystemMaintenanceSuccess(response)
          : sharedActionTriggers.GetSystemMaintenanceFailed(null)
      );
    });
  };

export const setSystemMaintenanceFromSignalR =
  (
    response: IErrorScreen
  ): ThunkAction<void, IStoreState, null, GetSystemMaintenanceAction> =>
  (dispatch) => {
    dispatch(sharedActionTriggers.GetSystemMaintenanceSignalRSuccess(response));
  };

export const setRBACConfiguration =
  (config: IRBACState): ThunkAction<void, IStoreState, null, RBACAction> =>
  async (dispatch) => {
    dispatch(sharedActionTriggers.SetRBACConfigurationSuccess(config));
  };
